import React from 'react'
import { useTrans } from 'hooks'
import { CategoriaHelpOnlineNode, PaginaNode } from '@gql/graphql'
import { ListingHead, Page } from 'components/organisms'
import styles from './FaqHubTemplate.module.sass'
import { IconTextCard } from '@components/molecules'
import { JsonLd, WContainer } from '@components/atoms'

interface Props {
  pagina?: PaginaNode
  categorieHelpOnline?: CategoriaHelpOnlineNode[]
}

const FaqHubTemplate = (props: Props) => {
  const { pagina = undefined, categorieHelpOnline = undefined } = props

  const t = useTrans()

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <ListingHead pagina={pagina} />
        <div className={styles.main}>
          <WContainer>
            <div className={styles.list}>
              {categorieHelpOnline?.map((c) => (
                <IconTextCard
                  key={c.pk}
                  item={{
                    pk: c.pk,
                    name: c.nome,
                    description: c.descrizione,
                    ctaLabel: t('Vai alle domande ({0})', [(c.risposte?.length || 0).toString()]),
                    url: c.url,
                  }}
                />
              ))}
            </div>
          </WContainer>
        </div>
      </main>
      <JsonLd type="organization" />
    </Page>
  )
}

export default FaqHubTemplate
